import {
	cs1,
	cs2,
	chat1,
	chat2,
	chat3,
	chat4,
	chat5,
	chat6,
	chat7,
	chat8,
	chat9,
	chat10,
	chat11,
	chat12,
	chat13,
} from '../assets/whatsapp';

export const chatsData = [
	{
		pp: cs1,
		contact: 'Prepseed',
		msg: 'Awesome, thank you!',
		time: '1:15 pm',
		unreadMsgs: null,
	},
	{
		pp: chat1,
		contact: 'Student 2',
		msg: 'Coding Spot is fire! 🔥',
		time: '12:15 pm',
		unreadMsgs: 2,
	},
	{
		pp: chat2,
		contact: 'Student 3',
		msg: "I won't be able to come today",
		time: '11:11 am',
		unreadMsgs: 4,
	},
	{
		pp: chat3,
		contact: 'Student4',
		msg: 'Hello sir',
		time: '11:04 am',
		unreadMsgs: null,
	},
	{
		pp: chat4,
		contact: '+91 123 4567890',
		msg: 'Who are you???',
		time: '10:58 am',
		unreadMsgs: null,
	},
	{
		pp: chat5,
		contact: 'Tech team </>',
		msg: 'We are going to build students whatsapp asap 🥳',
		time: '10:50 am',
		unreadMsgs: 23,
	},
	{
		pp: chat6,
		contact: 'Shweta mam',
		msg: 'I am taking extra class today',
		time: '10:35 am',
		unreadMsgs: 2,
	},
	{
		pp: chat7,
		contact: 'Assitant proff',
		msg: 'hey',
		time: '10:18 am',
		unreadMsgs: null,
	},
	{
		pp: chat8,
		contact: 'Director',
		msg: 'Meeting in 2 hours.',
		time: '10:02 am',
		unreadMsgs: null,
	},

	{
		pp: chat12,
		contact: 'Student prahladnagar',
		msg: 'I have doubt',
		time: 'yesterday',
		unreadMsgs: 6,
	},
	{
		pp: chat13,
		contact: 'Group of teachers',
		msg: 'We are doing good😭',
		time: 'yesterday',
		unreadMsgs: null,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: null,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: 7,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: null,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: 7,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: null,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: 7,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: null,
	},
	{
		pp: chat4,
		contact: 'Test',
		msg: 'Test chat ...',
		time: 'yesterday',
		unreadMsgs: 7,
	},
];

export const messagesData = [
	{
		msg: 'Can you share the attendance shee!t',
		time: '10:58 am',
		sent: true,
	},
	{
		msg: 'This is the students Whatsapp 🔥',
		time: '10:58 am',
		sent: true,
	},
	{
		msg: 'Keep it up! 👍👍👍',
		time: '10:59 am',
		sent: true,
	},
	{
		msg: 'Thanks a lot! 😀',
		time: '11:15 am',
		sent: false,
	},

	{
		msg: 'https://github.com/vanshitaroop',
		isLink: true,
		time: '11:36 am',
		sent: false,
	},
	{
		msg: "What's the Goal?",
		time: '11:47 am',
		sent: true,
	},
	{
		msg: 'PrepKey',
		time: '11:55 am',
		sent: false,
	},
	{
		msg: 'https://www.prepseed.com',
		isLink: true,
		time: '11:55 am',
		sent: false,
	},
	{
		img: cs1,
		time: '11:56 am',
		sent: false,
	},
	{
		msg: 'Good work! 🔥💯',
		time: '12:35 pm',
		sent: true,
	},

	{
		msg: 'Awesome, thank you🙌',
		time: '1:15 pm',
		sent: false,
	},
];
